import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.fixPageValue();
  }

  fixPageValue() {
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set("page", this.getCurentPage());
    window.history.replaceState(null, "", currentUrl.toString());
  }

  getCurentPage() {
    return this.element.getAttribute("data-current-page");
  }
}
